import {
    Button,
    TextField,
    Radio,
    IconButton,
    FormControlLabel,
    RadioGroup,
    InputAdornment,
} from '@material-ui/core';
import React, { useState, useEffect, useRef } from 'react';
import { cloneDeep } from 'lodash';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    removeCurrentGUIAddField,
    onCloseFieldExpandMore,
    getProjectNameOfField,
    isSystemField,
    duplicateField,
    getOrgName
} from '@/component/formManagement/handler/FieldListHandler';
import SettingFormDev from '@/component/formManagement/SettingFormDev';
import {
    updateParentFieldList,
    isAddNewField,
    onChangeFieldName,
    isUseFieldInForm,
    isFieldError,
    getErrorByField,
    isEditField,
    updateFormRecordNumber,
    isPermissionDeleteField,
    onChangeFieldNameREF,
    getIconFieldByTypeField,
    isDisplayOptionShareField
} from '../handler/CommonHandler';
import { duplicateField as duplicateFieldInForm } from '@/component/formManagement/handler/FormListHandler';
import ShareField from '../ShareField';
import FieldIdCommon from './FieldIdCommon';
import { useRecoilValue } from 'recoil';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';

export default function AddFieldTag(props) {
    console.log('AddFieldTag :>> ', 111);
    // Atom
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const corporationDetail = useRecoilValue(corporationAtom);

    // more action popover
    const [moreActionPopover, setMoreActionPopover] = useState(null);

    const indexAddField = Utils.findIndexInArrayById(props.currentAddField.id, props.fieldAddList);

    // const currentFieldData = props.fieldAddList[indexAddField];

    const [currentFieldData, setCurrentFielData] = useState(props.fieldAddList[indexAddField]);


    const [isUsingProject, setIsUsingProject] = useState(
        Utils.isEmpty(currentFieldData?.usingProjects)
            ? false
            : currentFieldData.usingProjects.includes(props.projectDetail.id)
    );
    const [isUsingForm, setIsUsingForm] = useState(
        Utils.isEmpty(currentFieldData?.isUsingForm) ? false : currentFieldData.isUsingForm
    );

    // console.log('props.currentAddField.id-------', props.currentAddField)

    const fieldRef = useRef('');

    const argsAll = {
        ...props,
        indexAddField,
        currentFieldData,
        isUsingProject,
        isUsingForm
    };

    useEffect(() => {
        setCurrentFielData(props.fieldAddList[indexAddField]);
    }, [props.fieldAddList[indexAddField]]);

    /** handler enter text input name */
    const onEnterTextInputName = event => {
        let textValue = event.target.value;
        if (event.key !== 'Enter') {
            return;
        }
        // let isValidate = validateAddFieldNameCustom(textValue, argsAll);
        // // if event diff enter then return
        // if (isValidate && props.isChangeData === false) {
        //     props.setIsChangeData(true);
        // }
        
        let newName = {
            jp: {
                A: 'F',
                text: textValue
            }
        };

        // reset fieldType selected
        let fieldTypeSelectedList = [...props.fieldTypeSelectedList];
        fieldTypeSelectedList = Utils.removeItemInArrayById(
            props.currentAddField.id,
            fieldTypeSelectedList
        );
        props.setFieldTypeSelectedList(fieldTypeSelectedList);
        props.fieldAddList[indexAddField].name = newName;
        props.fieldAddList[indexAddField].usingProjects = isUsingProject
            ? [props.projectDetail.id]
            : [];
        props.fieldAddList[indexAddField].isUsingProject = isUsingProject;
        props.fieldAddList[indexAddField].isErrorValidate = false;
        props.fieldAddList[indexAddField].isShowInfo = false;
        // update in field list or dragdrop data
        updateParentFieldList(props, currentFieldData, newName, isUsingProject);
    };

    /** handler addOptions */
    const onAddOptions = event => {
        let cloneFieldAddList = [...props.fieldAddList];
        cloneFieldAddList.splice(argsAll.indexAddField, 1, { ...currentFieldData });
        cloneFieldAddList[argsAll.indexAddField].publicForCustomer = props?.fieldAddList[argsAll.indexAddField]?.publicForCustomer

        if(props?.fieldAddList[argsAll.indexAddField]?.newShareOption){
            cloneFieldAddList[argsAll.indexAddField].newShareOption = props?.fieldAddList[argsAll.indexAddField]?.newShareOption
        }

        if(props?.fieldAddList[argsAll.indexAddField]?.newShareRange){
            cloneFieldAddList[argsAll.indexAddField].newShareRange = props?.fieldAddList[argsAll.indexAddField]?.newShareRange
        }

        props.setFieldAddList(cloneFieldAddList);
        props.setPanelScreen(Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_TAG_ITEM);
        props.setCurrentUpdateField(props.fieldAddList[indexAddField]);
    };

    /** handle event */
    const handleEvent = (eventType, event) => {
        let cloneFieldAddList = [...props.fieldAddList];
        let currentFieldDataClone = {...currentFieldData};

        switch (eventType) {
            // multiple
            case Constant.HANDLE_EVENT_TYPE.MULTIPLE_ADD_TAG_FIELD:
                currentFieldDataClone.structure.isMultiple = !currentFieldDataClone.structure.isMultiple;
                break;
            // select option
            case Constant.HANDLE_EVENT_TYPE.SELECT_OPTION_ADD_TAG_FIELD:
                currentFieldDataClone.structure.optionType =
                    Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE;
                break;
            // check option
            case Constant.HANDLE_EVENT_TYPE.CHECK_OPTION_ADD_TAG_FIELD:
                currentFieldDataClone.structure.optionType =
                    Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE;
                break;
            // recourd number
            case Constant.HANDLE_EVENT_TYPE.RECORD_NUMBER_ADD_TAG_FIELD:
                currentFieldDataClone.structure.recordNumber = event.target.value;
                break;
            // isAddItem
            case Constant.HANDLE_EVENT_TYPE.IS_ADD_ITEM_ADD_TAG_FIELD:
                currentFieldDataClone.structure.isAddItem = !cloneFieldAddList[
                    indexAddField
                ].structure.isAddItem;
                break;
            default:
                return;
        }

        cloneFieldAddList.splice(argsAll.indexAddField, 1, { ...currentFieldData });
        
        props.setFieldAddList(cloneFieldAddList);
        // if (Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, currentFieldData.name).length > 0) {
            props.setIsChangeData(true);
        // }
            
    };

    // update ref
    useEffect(() => {
        if (!Utils.isEmpty(currentFieldData) && !Utils.isEmpty(props.fieldRefList)) {
            props.fieldRefList[currentFieldData.id] = fieldRef;
        }
    });

    const isShowEditSelection = () => {
        let fieldListAddToForm = Utils.isEmptyArray(props.listFieldAddToForm) ? [] : [...props.listFieldAddToForm];
        let showEditSelection =  true;
        const prefixId = Utils.getPrefixOfId(props.currentAddField.id);
        if ((props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
            props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) &&
            prefixId !== 'dummy'
        ) {
            let cloneFieldAddToForm = cloneDeep(fieldListAddToForm);
            const indexFieldAddToForm = Utils.findIndexInArrayById(props.currentAddField.id, cloneFieldAddToForm);
            if (indexFieldAddToForm === -1) {
                showEditSelection = false;
            }
        }
        return showEditSelection;
    }

    const handleOnChangeFieldName = (e, args) => {
        let currentFieldDataClone = {...currentFieldData};
        currentFieldDataClone = onChangeFieldNameREF(e, currentFieldData, args);
        setCurrentFielData(currentFieldDataClone);
    }

    
    const renderCustomField = () => {
        return (
            <li
                className={
                    isUseFieldInForm(currentFieldData, props.formList, argsAll)
                        ? 'listField-li'
                        : 'listField-li background-color-usingForm'
                }
                id={currentFieldData.id}
                // ref={props.fieldRefList[props.currentUpdateField.id]}
                ref={fieldRef}
                style={{ width: '100%' }}
            >
                <div
                    className={
                        isUseFieldInForm(currentFieldData, props.formList, argsAll)
                            ? 'fieldSetting-info fieldSetting-info--changeForm'
                            : 'fieldSetting-info fieldSetting-info--changeForm background-color-usingForm'
                    }
                >
                    <div className="fieldSetting-thumb">
                        <img src="/assets/image/icon-field.svg" alt="" />
                    </div>
                    <div className="fieldSetting-cmt">
                        <div className="fieldSetting-name add-field-tag">
                            <div className="formCreate">
                                <TextField
                                    className="form-input-outlined"
                                    placeholder="フィールド名"
                                    onKeyPress={onEnterTextInputName}
                                    // onChange={e => onChangeFieldName(e, argsAll)}
                                    onChange={e => handleOnChangeFieldName(e, argsAll)}
                                    defaultValue={Utils.getTextByLanguage(
                                        Constant.LANGUAGE_TYPE.JP,
                                        currentFieldData.name
                                    )}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                    error={isFieldError('name', currentFieldData)}
                                    helperText={getErrorByField('name', currentFieldData)}
                                    onBlur={e => onChangeFieldName(e, argsAll)}
                                />
                            </div>
                            <p className="fieldSetting-text">
                                {getProjectNameOfField(currentFieldData, props.projectList)}
                            </p>
                            {currentFieldData?.affiliationOrganization !== props.corporationDetail.id && (
                                <p className="fieldSetting-text  --3">
                                    {getOrgName(props?.allListCorp ,currentFieldData?.affiliationOrganization)}
                                </p>
                            )}
                        </div>
                        <div className="fieldSetting-autofill">
                            <div
                                className={
                                    isUseFieldInForm(currentFieldData, props.formList, argsAll)
                                        ? 'fieldSetting-item'
                                        : 'fieldSetting-item background-color-usingForm'
                                }
                            >
                                {!isSystemField(currentFieldData) &&
                                    !isAddNewField(currentFieldData) && (
                                        <>
                                            <IconButton
                                                className="itemTools"
                                                onClick={e => {
                                                    setMoreActionPopover(null);
                                                    if (
                                                        props.parentPanelScreen ===
                                                        Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD
                                                    ) {
                                                        duplicateField(props, currentFieldData);
                                                    } else if (
                                                        [
                                                            'listFieldAddToForm',
                                                            'listFieldInProject'
                                                        ].includes(props.regionDropIdBlock)
                                                    ) {
                                                        duplicateFieldInForm(
                                                            props,
                                                            currentFieldData,
                                                            props.regionDropIdBlock
                                                        );
                                                    }
                                                     props.setIsChangeData(true);
                                                }}
                                            >
                                                <img src="/assets/image/icon-copy.svg" alt="" />
                                            </IconButton>
                                            {isPermissionDeleteField(
                                                currentFieldData,
                                                props.formList,
                                                argsAll
                                            ) && (
                                                <IconButton className="itemTools">
                                                    <img
                                                        src="/assets/image/icon-tabs-delete.svg"
                                                        alt=""
                                                        onClick={e => {
                                                            props.handleClick(e);
                                                            props.setCurrentFieldSelected(
                                                                props.currentAddField
                                                            );
                                                            props.setIsOpenConfirmDeleteModal(true);
                                                            props.handleClose();
                                                        }}
                                                    />
                                                </IconButton>
                                            )}
                                            {!props.disableBtnShowMore && (
                                                <IconButton
                                                    className="itemTools itemTools-arrow"
                                                    onClick={e =>
                                                        onCloseFieldExpandMore(
                                                            props,
                                                            currentFieldData
                                                        )
                                                    }
                                                >
                                                    <img
                                                        src="/assets/image/icon-arrow-accordion-gray.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            )}
                                        </>
                                    )}
                                {!isSystemField(currentFieldData) &&
                                    isAddNewField(currentFieldData) && (
                                        <>
                                            <IconButton
                                                className="itemTools"
                                                onClick={event => {
                                                    setMoreActionPopover(null);
                                                    removeCurrentGUIAddField(props);
                                                }}
                                            >
                                                <img
                                                    src="/assets/image/icon-tabs-delete.svg"
                                                    alt=""
                                                />
                                            </IconButton>

                                            {!props.disableBtnShowMore && (
                                                <IconButton
                                                    className="itemTools itemTools-arrow"
                                                    onClick={e =>
                                                        onCloseFieldExpandMore(
                                                            props,
                                                            currentFieldData
                                                        )
                                                    }
                                                >
                                                    <img
                                                        src="/assets/image/icon-arrow-accordion-gray.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            )}
                                        </>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fieldSetting-content">
                    <FieldIdCommon fieldId={props.currentAddField?.id}/>
                    <div className="lstCreateForm lstCreateForm--changePt">
                        <p className="lstCreateForm-text">複数選択</p>
                        <div className="lstCreateForm-control">
                            <div className="switch-check">
                                <input
                                    data-cy="add-tag-field-input-multi-check"
                                    type="checkbox"
                                    id={`switch-show-all-chat-post-${props.currentAddField.id}`}
                                    defaultChecked={currentFieldData.structure.isMultiple}
                                    onChange={event => {
                                        handleEvent(
                                            Constant.HANDLE_EVENT_TYPE.MULTIPLE_ADD_TAG_FIELD,
                                            event
                                        );
                                    }}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                />
                                <label
                                    for={`switch-show-all-chat-post-${props.currentAddField.id}`}
                                ></label>
                            </div>
                        </div>
                    </div>
                    {/* checkbox */}
                    <div
                        className="lstCreateForm lstCreateForm--changePt"
                        data-cy="add-number-field-unit-position"
                    >
                        <p className="lstCreateForm-text">選択方法</p>
                        <div className="lstCreateForm-control">
                            <RadioGroup
                                className="multiple-radioLst"
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="後"
                                name="radio-buttons-group"
                            >
                                <FormControlLabel
                                    className="custom-radio"
                                    value="セレクト"
                                    control={<Radio />}
                                    label="セレクト"
                                    data-cy="add-tag-field-radio-select"
                                    checked={
                                        currentFieldData.structure.optionType ===
                                        Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE
                                    }
                                    onChange={event =>
                                        handleEvent(
                                            Constant.HANDLE_EVENT_TYPE.SELECT_OPTION_ADD_TAG_FIELD,
                                            event
                                        )
                                    }
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'A' }}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                />
                                <FormControlLabel
                                    className="custom-radio"
                                    value="チェック"
                                    control={<Radio />}
                                    label="チェック"
                                    data-cy="add-tag-field-radio-checkbox"
                                    checked={
                                        currentFieldData.structure.optionType ===
                                        Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE
                                    }
                                    onChange={event =>
                                        handleEvent(
                                            Constant.HANDLE_EVENT_TYPE.CHECK_OPTION_ADD_TAG_FIELD,
                                            event
                                        )
                                    }
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'A' }}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                />
                            </RadioGroup>
                        </div>
                    </div>
                    <div className="selectedNumber">
                        <div className="groupNumber">
                            <p className="selectedNumber-text">選択項目の最大表示数</p>
                            <div className="formNumber">
                                <TextField
                                    className="form-control-wrapInput form-control-hg32"
                                    variant="outlined"
                                    type="number"
                                    placeholder=""
                                    defaultValue={currentFieldData.structure.recordNumber}
                                    value={currentFieldData.structure.recordNumber}
                                    onChange={event =>
                                        handleEvent(
                                            Constant.HANDLE_EVENT_TYPE.RECORD_NUMBER_ADD_TAG_FIELD,
                                            event
                                        )
                                    }
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                    data-cy="add-tag-field-input-max-item-show"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment>
                                                <div className="formButton">
                                                    <Button
                                                        className="btnNumber up"
                                                        onClick={() => {
                                                            updateFormRecordNumber(
                                                                props,
                                                                currentFieldData.name,
                                                                parseInt(
                                                                    currentFieldData.structure
                                                                        .recordNumber + 1
                                                                ),
                                                                indexAddField
                                                            );
                                                        }}
                                                        disabled={
                                                            !isEditField(currentFieldData, argsAll)
                                                        }
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-nav.svg"
                                                            alt=""
                                                        />
                                                    </Button>
                                                    <Button
                                                        className="btnNumber down"
                                                        onClick={() => {
                                                            updateFormRecordNumber(
                                                                props,
                                                                currentFieldData.name,
                                                                parseInt(
                                                                    currentFieldData.structure
                                                                        .recordNumber - 1
                                                                ),
                                                                indexAddField
                                                            );
                                                        }}
                                                        disabled={
                                                            !isEditField(currentFieldData, argsAll)
                                                        }
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-nav.svg"
                                                            alt=""
                                                        />
                                                    </Button>
                                                </div>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    
                    {/* btn add item tag */}
                    {!isSystemField(currentFieldData) && isShowEditSelection() && (
                        <div className="editSelection">
                            <a
                                className="editSelection-text"
                                href="javascript:void(0)"
                                onClick={onAddOptions}
                            >
                                <span
                                    className="itemEdit"
                                    variant="contained"
                                    color="primary"
                                    data-cy="edit-item-tag-field-btn"
                                >
                                    <img src="/assets/image/icon-editSelection.svg" alt="" />
                                </span>
                                選択項目編集
                            </a>
                        </div>
                    )}
                </div>

                {/* Share option */}
                {isDisplayOptionShareField(props?.parentPanelScreen, projectInuseDetail?.id, currentFieldData.affiliationProject, corporationDetail?.rootFlag) && <ShareField {...props} />}
                
                {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
                    props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) && (
                    <SettingFormDev {...props} />
                )}
            </li>
        );
    };

    const renderSystemFieldForm = () => {
        return (
            <li
                id={currentFieldData.id}
                ref={fieldRef}
            >
                <div className="fieldSetting-info">
                    <div className="fieldSetting-thumb">
                    <img src={`${getIconFieldByTypeField(currentFieldData)}`} alt="" />
                    </div>
                    <div className="fieldSetting-cmt">
                        <div className="fieldSetting-name">
                            <p className="fieldSetting-tlt">
                                {' '}
                                {Utils.getTextByLanguage(
                                    Constant.LANGUAGE_TYPE.JP,
                                    currentFieldData.name
                                )}
                            </p>
                            <p className="fieldSetting-text">
                                {' '}
                                {getProjectNameOfField(currentFieldData, props.projectList)}
                            </p>
                        </div>
                        <div className="fieldSetting-autofill">
                            <p className="fieldSetting-text">
                                {' '}
                                {isSystemField(currentFieldData) && !props.addFormType
                                    ? '自動入力'
                                    : ''}
                            </p>
                            <div className="fieldSetting-item">
                                <IconButton
                                    className="itemTools itemTools-arrow"
                                    onClick={e => onCloseFieldExpandMore(props, currentFieldData)}
                                >
                                    <img src="/assets/image/icon-arrow-accordion-gray.svg" alt="" />
                                </IconButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="fieldSetting-content">
                    <FieldIdCommon fieldId={props.currentAddField?.id}/>
                    <div className="lstCreateForm lstCreateForm--changePt">
                        <p className="lstCreateForm-text">複数選択</p>
                        <div className="lstCreateForm-control">
                            <div className="switch-check">
                                <input
                                    data-cy="add-tag-field-input-multi-check"
                                    type="checkbox"
                                    id={`switch-show-all-chat-post-${props.currentAddField.id}`}
                                    defaultChecked={currentFieldData.structure.isMultiple}
                                    onChange={event => {
                                        handleEvent(
                                            Constant.HANDLE_EVENT_TYPE.MULTIPLE_ADD_TAG_FIELD,
                                            event
                                        );
                                    }}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                />
                                <label
                                    for={`switch-show-all-chat-post-${props.currentAddField.id}`}
                                ></label>
                            </div>
                        </div>
                    </div>
                    {/* checkbox */}
                    <div
                        className="lstCreateForm lstCreateForm--changePt"
                        data-cy="add-number-field-unit-position"
                    >
                        <p className="lstCreateForm-text">選択方法</p>
                        <div className="lstCreateForm-control">
                            <RadioGroup
                                className="multiple-radioLst"
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="後"
                                name="radio-buttons-group"
                            >
                                <FormControlLabel
                                    className="custom-radio"
                                    value="セレクト"
                                    control={<Radio />}
                                    label="セレクト"
                                    data-cy="add-tag-field-radio-select"
                                    checked={
                                        currentFieldData.structure.optionType ===
                                        Constant.TAG_FIELD_DEFAULT.SELECT_OPTION_TYPE
                                    }
                                    onChange={event =>
                                        handleEvent(
                                            Constant.HANDLE_EVENT_TYPE.SELECT_OPTION_ADD_TAG_FIELD,
                                            event
                                        )
                                    }
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'A' }}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                />
                                <FormControlLabel
                                    className="custom-radio"
                                    value="チェック"
                                    control={<Radio />}
                                    label="チェック"
                                    data-cy="add-tag-field-radio-checkbox"
                                    checked={
                                        currentFieldData.structure.optionType ===
                                        Constant.TAG_FIELD_DEFAULT.CHECK_OPTION_TYPE
                                    }
                                    onChange={event =>
                                        handleEvent(
                                            Constant.HANDLE_EVENT_TYPE.CHECK_OPTION_ADD_TAG_FIELD,
                                            event
                                        )
                                    }
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'A' }}
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                />
                            </RadioGroup>
                        </div>
                    </div>
                    <div className="selectedNumber">
                        <div className="groupNumber">
                            <p className="selectedNumber-text">選択項目の最大表示数</p>
                            <div className="formNumber">
                                <TextField
                                    className="form-control-wrapInput form-control-hg32"
                                    variant="outlined"
                                    type="number"
                                    placeholder=""
                                    defaultValue={currentFieldData.structure.recordNumber}
                                    value={currentFieldData.structure.recordNumber}
                                    onChange={event =>
                                        handleEvent(
                                            Constant.HANDLE_EVENT_TYPE.RECORD_NUMBER_ADD_TAG_FIELD,
                                            event
                                        )
                                    }
                                    disabled={!isEditField(currentFieldData, argsAll)}
                                    data-cy="add-tag-field-input-max-item-show"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment>
                                                <div className="formButton">
                                                    <Button
                                                        className="btnNumber up"
                                                        onClick={() => {
                                                            updateFormRecordNumber(
                                                                props,
                                                                currentFieldData.name,
                                                                parseInt(
                                                                    currentFieldData.structure
                                                                        .recordNumber + 1
                                                                ),
                                                                indexAddField
                                                            );
                                                        }}
                                                        disabled={
                                                            !isEditField(currentFieldData, argsAll)
                                                        }
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-nav.svg"
                                                            alt=""
                                                        />
                                                    </Button>
                                                    <Button
                                                        className="btnNumber down"
                                                        onClick={() => {
                                                            updateFormRecordNumber(
                                                                props,
                                                                currentFieldData.name,
                                                                parseInt(
                                                                    currentFieldData.structure
                                                                        .recordNumber - 1
                                                                ),
                                                                indexAddField
                                                            );
                                                        }}
                                                        disabled={
                                                            !isEditField(currentFieldData, argsAll)
                                                        }
                                                    >
                                                        <img
                                                            src="/assets/image/icon-arrow-nav.svg"
                                                            alt=""
                                                        />
                                                    </Button>
                                                </div>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    
                    {/* btn add item tag */}
                    {!isSystemField(currentFieldData) && isShowEditSelection() && (
                        <div className="editSelection">
                            <a
                                className="editSelection-text"
                                href="javascript:void(0)"
                                onClick={onAddOptions}
                            >
                                <span
                                    className="itemEdit"
                                    variant="contained"
                                    color="primary"
                                    data-cy="edit-item-tag-field-btn"
                                >
                                    <img src="/assets/image/icon-editSelection.svg" alt="" />
                                </span>
                                選択項目編集
                            </a>
                        </div>
                    )}
                </div>

                {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
                    props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) && (
                    <SettingFormDev {...props} />
                )}
            </li>
        );
    };

    return (
        <>
            {indexAddField === -1 ? (
                <></>
            ) : (
                <>
                    {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM || 
                    props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) && isSystemField(currentFieldData) && renderSystemFieldForm()}
                    {!isSystemField(currentFieldData) && renderCustomField()}
                </>
            )}
        </>
    );
}
